import { render, staticRenderFns } from "./visualizar-parcelamento.vue?vue&type=template&id=227ca562&scoped=true"
import script from "./visualizar-parcelamento.vue?vue&type=script&lang=js"
export * from "./visualizar-parcelamento.vue?vue&type=script&lang=js"
import style0 from "./visualizar-parcelamento.vue?vue&type=style&index=0&id=227ca562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ca562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDataTable,
  VExpansionPanel,
  VExpansionPanelContent,
  VIcon,
  VTooltip,
})
